import { useSelector } from 'react-redux';
import { selectDelivery } from '@store/order/selectors';
import { CountryEnum } from '@api/types/CountryEnum';
import { PricingModel } from '@api/types/PricingModel';
import { renderPrice } from '@components/utils';



interface LetterProps {
	price: PricingModel | null | undefined,
	country: CountryEnum,
}


const Letter = (props: LetterProps): JSX.Element => {
	const { price, country } = props;

	const delivery = useSelector(selectDelivery);
	const productPrice = price && delivery ? renderPrice(price.priceWithVat - delivery.price) : '0';
	const productPriceNoVat = price && delivery ? renderPrice(price.priceNoVat - delivery.price) : '0';

	if (!delivery) return (
		<></>	
	)

	return (
		<div className='order-summary-element letter-element'>
			<p>Krásný den, zdravíme z&nbsp;VETlímce,</p>
			<p>děkujeme Vám za&nbsp;zájem o&nbsp;naše produkty a&nbsp;jménem Vašeho chlupáče i&nbsp;za&nbsp;to, že&nbsp;pro&nbsp;něj chcete to&nbsp;nejlepší. Vyhodnotili jsme údaje o&nbsp;Vašem kamarádovi a&nbsp;pokud nám k&nbsp;tomu dáte svolení, můžeme se&nbsp;pustit do&nbsp;výroby VETlímce. Ten ušijeme přímo na&nbsp;míru&nbsp;dle stavby těla zvířete, ale i&nbsp;jeho povahy a&nbsp;umístění zranění. Máte tak&nbsp;jistotu, že&nbsp;padne jako ulitý, zabrání kontaktu s&nbsp;ránou a&nbsp;dopřeje tolik potřebný klid pro&nbsp;uzdravení.</p>
			<p>Límec vyrobíme z&nbsp;molitanového základu, jehož sílu přizpůsobíme údajům o&nbsp;zvířeti, které&nbsp;jsme od&nbsp;Vás dostali. Samozřejmě Vám garantujeme vzor látky, který&nbsp;jste si vybrali. Látka je&nbsp;nejen krásná, ale i&nbsp;praktická, jde o&nbsp;omyvatelnou kočárkovinu, jež stačí v&nbsp;případě běžného znečistění pouze otřít vlhkým hadříkem. Tento materiál je&nbsp;také velmi odolný a&nbsp;připravený na&nbsp;opětovné použití, límec Vašemu čtyřnohému příteli tak&nbsp;může sloužit v&nbsp;případě potřeby opakovaně, třeba i&nbsp;celý život.</p>
			<p>Uděláme všechno pro&nbsp;to, abychom Vám límec dodali v&nbsp;termínu, který&nbsp;jste vyznačili ve&nbsp;formuláři. Pokud by&nbsp;se&nbsp;v&nbsp;tomto ohledu vyskytly komplikace, určitě Vám obratem dáme vědět a&nbsp;Vy sami se&nbsp;rozhodnete, zda límec chcete dodat, či&nbsp;nikoliv.</p>
			<p>Nyní schází poslední krok, závazně potvrdit objednávku VETlímce a&nbsp;dopřát chlupáčkovi pohodlnou rekonvalescenci bez zbytečného stresu z&nbsp;plastového krunýře, který&nbsp;podle nových vědeckých poznatků dokonce zpomaluje samotný proces uzdravení.</p>

			{price && price.priceNoVat > 0 && <p className='with-margin'>{
				'VETlímec na\u00a0míru by\u00a0pro\u00a0Vašeho zvířecího kamaráda vyšel na\u00a0' +
				`${productPrice}\u00a0${country === CountryEnum.sk ? '\u20AC' : 'Kč'} ` +
				`(${productPriceNoVat}\u00a0${country === CountryEnum.sk ? '\u20AC' : 'Kč'} bez\u00a0DPH)` +
				', plus poštovné, které\u00a0jste zvolili, tedy ' + 
				`${renderPrice(price.priceWithVat)}\u00a0${country === CountryEnum.sk ? '\u20AC' : 'Kč'} ` +
				`(${renderPrice(price.priceNoVat)}\u00a0${country === CountryEnum.sk ? '\u20AC' : 'Kč'} bez\u00a0DPH).`
			}</p>}

			{price && price.priceNoVat > 0 && <p>Pokud s&nbsp;cenou souhlasíte, klikněte na&nbsp;tlačítko ZÁVAZNĚ OBJEDNAT a&nbsp;my se&nbsp;hned pustíme do&nbsp;práce.</p>}

			<p className='with-margin'>Těšíme se&nbsp;na&nbsp;odezvu a&nbsp;za&nbsp;Vašeho kamaráda máme velkou radost, že&nbsp;mu chcete ulehčit a&nbsp;dopřát ve&nbsp;složitých chvílích maximální pohodlí!</p>
			<p>Pokud máte jakékoliv dotazy, neváhejte nás kontaktovat.</p>

			<p className='with-margin'>S&nbsp;pozdravem za&nbsp;VETlímce<br />
				Veronika&nbsp;Čechová</p>

			<p className='with-margin'>Zákaznický&nbsp;servis<br />
				+430&nbsp;734&nbsp;562&nbsp;220<br />
				veronika.cechova@vetlimce.cz</p>
		</div>
	);
};

export default Letter;